var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message',{attrs:{"text":"Stel uw vraag, het gesprek wordt daarna gestart.","user":"THEM","isFirstChild":true}})}
var staticRenderFns = []

export { render, staticRenderFns }